<template>
  <div id="promotion-banner" class="container">
    <div class="row">
      <div class="col-md-12">
        <img class="img-fluid" :src="promotion.banner" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromotionBanner",
  props: {
    promotion: Object,
  },
};
</script>
